import { Accordion, AccordionContent, AccordionSummary } from "../uikit";
import { useState } from "react";
import styles from "./policies.module.css";
import { useTranslation } from "react-i18next";

import ruPolicies from "../components/policies/ru";
import enPolicies from "../components/policies/en";

export default function Policies() {
  const { t, i18n } = useTranslation();
  const [isRulesOpen, setIsRulesOpen] = useState(false);
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);

  // i18n.language, а не статический lang из ../i18n: useTranslation
  // перерисовывает компонент при смене языка, политики переключаются на лету
  const policies = i18n.language === "ru" ? ruPolicies : enPolicies;

  return (
    <div>
      <Accordion expanded={isRulesOpen} onChange={setIsRulesOpen}>
        <AccordionSummary>{t("Terms of service")}</AccordionSummary>
        <AccordionContent>
          <div className={styles.row}>{policies["TermsOfService"]()}</div>
        </AccordionContent>
      </Accordion>
      <Accordion expanded={isPrivacyOpen} onChange={setIsPrivacyOpen}>
        <AccordionSummary>{t("Privacy policy")}</AccordionSummary>
        <AccordionContent>
          <div className={styles.row}>{policies["PrivacyPolicy"]()}</div>
        </AccordionContent>
      </Accordion>
      {/* <Accordion expanded={isRefundOpen} onChange={setIsRefundOpen}>
        <AccordionSummary>{t("Refund policy")}</AccordionSummary>
        <AccordionContent>
          <div className={styles.row}>{policies["RefundPolicy"]()}</div>
        </AccordionContent>
      </Accordion> */}
    </div>
  );
}
